<template>
  <div class="h-100 wrapper">
    <skeleton-wrapper :is-loading="isLoading">
      <template v-slot:skeleton>
        <life-transitions-widget-skeleton />
      </template>
      <template v-slot:content>
        <div class="mb-4 h-100" v-if="transitions.length > 0 && hasTransitions">
          <actionable-card
            :primary-title="trans('widgets.life_transitions.title')"
            :description="trans('widgets.life_transitions.description')"
            :button-text="trans('widgets.life_transitions.button')"
            buttonSize="sm"
            @primaryClicked="onPlusButtonClick"
          >
            <template v-slot:extra-body>
              <div
                v-for="(item, index) in transitionsToShow"
                :key="index"
                class="d-flex align-items-center item"
                :class="{ 'has-placeholder': !item.text }"
              >
                <div
                  class="icon d-flex justify-content-center align-items-center mr-2"
                  v-if="item.text"
                >
                  {{ item.emoticon }}
                </div>
                {{ item.text }}
              </div>
              <b-button
                v-if="buttonCount > 0"
                @click="onEditButtonClick"
                variant="info"
                pill
                size="sm"
                class="px-3 mt-4"
              >
                +{{ buttonCount }}
              </b-button>
            </template>
          </actionable-card>
        </div>
        <div v-else class="border-top border-bottom py-4">
          <h5 class="mt-3">{{ trans("widgets.life_transitions.empty.title") }}</h5>
          <p>{{ trans("widgets.life_transitions.empty.description") }}</p>

          <div class="d-flex justify-content-end">
            <b-button size="sm" @click="onDiscoverMoreClick">
              {{ trans("widgets.life_transitions.empty.button") }}
            </b-button>
          </div>
        </div>
      </template>
    </skeleton-wrapper>
  </div>
</template>

<script>
import ActionableCard from "../../molecules/cards/ActionableCard";
import SkeletonWrapper from "../../organisms/SkeletonWrapper";
import LifeTransitionsWidgetSkeleton from "../../molecules/skeletons/LifeTransitionsWidgetSkeleton";

export default {
  name: "LifeTransitionsWidget",
  components: { ActionableCard, SkeletonWrapper, LifeTransitionsWidgetSkeleton },
  props: {
    hasTransitions: Boolean,
  },
  data() {
    return {
      isLoading: true,
      transitionsToShowLength: 4,
      transitions: [],
    };
  },
  methods: {
    onDiscoverMoreClick() {
      trackEvent("OpenComunityFromLifeTransition", {});
      this.$router.push({ name: "community-posts" });
    },
    onEditButtonClick() {
      trackEvent("EditLifeTransition", {});
      this.openProfileTransitions();
    },
    onPlusButtonClick() {
      trackEvent("PlusLifeTransition", {});
      this.openProfileTransitions();
    },
    openProfileTransitions() {
      this.$router.push({ name: "profile-transitions" });
    },
    itemIcon(text) {
      return text.substring(0, text.indexOf(" "));
    },
    itemText(text) {
      return text.substring(text.indexOf(" ") + 1);
    },
  },
  computed: {
    buttonCount() {
      return this.transitions.length - this.transitionsToShowLength * 2;
    },
    transitionsToShow() {
      return this.transitions.slice(0, this.transitionsToShowLength);
    },
  },
  mounted() {
    if (this.hasTransitions) {
      this.$axios
        .get("/api/rest/home/lifeTransitions")
        .then((res) => {
          this.isLoading = false;
          const mockItem = {
            id: "",
            text: "",
            emoticon: "",
          };
          const data = res.data;

          if (data.length > 0) {
            this.transitions = new Array(this.transitionsToShowLength).fill(mockItem);
            this.transitions.unshift(...data);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped lang="scss">
.item {
  background-color: $color-white;
  padding-top: 13px;

  &.has-placeholder {
    background: url("/images/item-placeholder.svg") no-repeat left bottom;
    min-height: 53px;
  }
}
.icon {
  border: 3px solid $color-orange;
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 100%;
}

.wrapper {
  min-height: 300px;
}
</style>
